export default "__VITE_ASSET__CLmKZsyZ__"